/* eslint-disable no-unused-vars */
/* eslint-disable import/extensions */
import Head from 'next/head';
import Image from 'next/image';
import React, { createContext, useContext, useEffect, useReducer, useState, } from 'react';
import { Col, Navbar, Row, } from 'react-bootstrap';
import { MessagesContext } from '@/pages/_app';
import { layout, messages, http, version, help, } from '@/helpers/index';
import { auth } from '@/services/auth';
import Messages from '@/components/messages';
import Toasts from '@/components/toasts';
import Loading from '@/components/loading';
import MenusCrm from '@/components/menus/crm';
import ToolbarCrm from '@/components/menus/toolbar-crm';
import Divider from '../divider';
import HelpComponent from '../actions/help';

export const HelpContext = createContext(help.init());

export default function LayoutComponent({ code, children }) {
  const [showChild, setShowChild] = useState(false);
  const { stateMessages, dispatchMessages } = useContext(MessagesContext);
  const [stateHelp, dispatchHelp] = useReducer(help.reduce, help.init());
  const user = auth.store.logged.get();

  help.configure(dispatchHelp);

  const titles = {
    managerMix: 'MIX - Gerenciamento',
    monitorMix: 'MIX - Monitoramento',
    adminMix: 'MIX - Administração',
    mix: 'MIX',
  };

  useEffect(() => {
    setShowChild(true);
    if (!user) { return; }
    http.get('/helps', (result) => {
      if (result) {
        const items = [];
        result.forEach((el) => {
          if (el.category !== 'USER' && el.category !== 'REPORT') {
            items.push(el);
          }
        })
        help.dispatch({
          type: 'LOAD',
          payload: items,
        });
      }
    });
  }, []);
  if (!showChild || typeof window === 'undefined') { return null; }
  return (
    <HelpContext.Provider value={{ stateHelp, dispatchHelp }}>
      <Head />
      <header className="crm">
        <Navbar id="navbar" bg="default" expand="md" fixed="top" className="not-printable ps-4 pe-4 shadow-sm">
          <Navbar.Brand href="/" onClick={layout.menu.close}>
            <Image src="/assets/themes/default/images/logo-crm.png" width="247" height="55" border="0" alt="Logomarca da AboutCar" quality={75} />
          </Navbar.Brand>
          <MenusCrm code={code} />
        </Navbar>
        <HelpComponent state={stateHelp} />
      </header>
      <div className="crm container-fluid">
        <Row>
          <main className="ms-sm-auto px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
              <h1>{titles[code]}</h1>
              <ToolbarCrm />
            </div>
            <Messages items={stateMessages.messages} clear={messages.clear} />
            {children}
            <footer>
              <Divider crm />
              <Col xs={12} className="lead text-center">
                &copy;
                {` ${new Date().getFullYear()} AboutCar - ${version.crm} - Todos os direitos reservados`}
              </Col>
            </footer>
          </main>
        </Row>
      </div>
      <Loading />
      <Toasts items={stateMessages.messages} clear={messages.clear} />
    </HelpContext.Provider>
  );
}
